/* Fit complete inclusion values and labels without line breaks or truncation. */
(() => {
  'use strict';
  if (window.edmtOverviewTypography) return;
  window.edmtOverviewTypography = true;
  const grids = new Set();
  const widths = new WeakMap();
  const pending = new Set();
  let frame;

  const fit = grid => {
    if (!grid.clientWidth) return;
    const items = [...grid.querySelectorAll('dt, dd')];
    grid.removeAttribute('data-fitting-columns');
    items.forEach(item => item.style.removeProperty('font-size'));
    // Measure the actual loaded font, including uppercase letter widths.
    const measure = () => items.map(item => {
      const range = document.createRange();
      range.selectNodeContents(item);
      const textWidth = range.getBoundingClientRect().width;
      const available = item.getBoundingClientRect().width - 1;
      const base = parseFloat(getComputedStyle(item).fontSize);
      return textWidth > available && available > 0
        ? Math.floor(base * available / textWidth * 100) / 100
        : base;
    });
    let sizes = measure();
    let columns = getComputedStyle(grid).gridTemplateColumns.split(' ').length;
    // Use fewer columns before a long caption becomes too small to read.
    while (columns > 1 && sizes.some((size, index) => size < (items[index].tagName === 'DT' ? 9 : 16))) {
      columns = columns === 4 ? 2 : 1;
      grid.setAttribute('data-fitting-columns', columns);
      sizes = measure();
    }
    items.forEach((item, index) => { item.style.fontSize = sizes[index] + 'px'; });
  };
  const schedule = grid => {
    pending.add(grid);
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = null;
      pending.forEach(fit);
      pending.clear();
    });
  };
  const observer = window.ResizeObserver && new ResizeObserver(entries => {
    entries.forEach(entry => {
      const width = entry.contentRect.width;
      if (widths.get(entry.target) === width) return;
      widths.set(entry.target, width);
      schedule(entry.target);
    });
  });
  const init = () => {
    document.querySelectorAll('.edmt-overview__specs').forEach(grid => {
      if (grids.has(grid)) return;
      grids.add(grid);
      fit(grid);
      if (observer) observer.observe(grid);
    });
  };
  init();
  document.addEventListener('shopify:section:load', init);
  if (!observer) window.addEventListener('resize', () => grids.forEach(schedule));
  if (document.fonts) {
    document.fonts.ready.then(() => grids.forEach(schedule));
    document.fonts.addEventListener('loadingdone', () => grids.forEach(schedule));
  }
})();
